import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { runtimeEnvironment } from '../../environments/environment';

export type Stage = { text: string; icon: string };
export type StageSet = { [index: string]: Stage };
export interface IWorkInProgressComponentData {
  title: string;
  stages: StageSet;
}

/**
 * Receives status updates and displays the appropriate "stage" (i.e. an icon and text).
 */
@Component({
    selector: 'app-workflow-in-progress',
    templateUrl: 'workflow-in-progress.component.html',
    styleUrls: [
        './workflow-in-progress.component.scss',
        './web-app.workflow-in-progress.scss',
        './chrome-extension.workflow-in-progress.scss',
    ],
    standalone: false
})
export class WorkflowInProgressComponent {
  renderMode = runtimeEnvironment.renderMode;
  originNamespace = runtimeEnvironment.origin.namespace;
  visible = false;
  icon = '';
  text = '';
  title = '';

  private readonly stages: StageSet;

  constructor(@Inject(MAT_DIALOG_DATA) private data: IWorkInProgressComponentData) {
    console.debug('WorkflowInProgressComponent created.');
    this.title = data.title;
    this.stages = data.stages;
  }

  receiveStatus(status: string): void {
    const stage: Stage = this.stages[status];
    if (stage) {
      this.showStage(stage);
    } else {
      console.debug(`No stage found for ${status}.`);
    }
  }

  showStage(stage: Stage): void {
    this.text = stage.text;
    this.icon = stage.icon;
    this.visible = true;
  }
}
